import { render, staticRenderFns } from "./DetailWalletReport.vue?vue&type=template&id=6c10bea2&scoped=true&"
import script from "./DetailWalletReport.vue?vue&type=script&lang=js&"
export * from "./DetailWalletReport.vue?vue&type=script&lang=js&"
import style0 from "./DetailWalletReport.vue?vue&type=style&index=0&id=6c10bea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c10bea2",
  null
  
)

export default component.exports